// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"7bf9a94c","799":"7b3413b4","989":"7bf9a94c"}[chunkId] + ".chunk.css";
};